import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { equals } from "ramda";

import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles(theme => ({
  count: {
    color: theme.palette.primary.brandPrimary,
    marginRight: 10,
    fontSize: "24px",
    lineHeight: "34px",
    fontWeight: "700",
  },
}));

const ContentTotalsHeader = ({ count }) => {
  const classes = useStyles();

  return (
    <Grid item className={classes.count}>
      {`${count.toLocaleString()} ${equals(count, 1) ? "item" : "items"}`}
    </Grid>
  );
};

export default ContentTotalsHeader;
